import { render, staticRenderFns } from "./payment-view.vue?vue&type=template&id=06905976&scoped=true"
import script from "./payment-view.vue?vue&type=script&lang=js"
export * from "./payment-view.vue?vue&type=script&lang=js"
import style0 from "./payment-view.vue?vue&type=style&index=0&id=06905976&prod&scoped=true&lang=css"
import style1 from "./payment-view.vue?vue&type=style&index=1&id=06905976&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06905976",
  null
  
)

export default component.exports